import {t} from "@lingui/macro";

export const businessCategories = [
    {
        value: 'craftsman',
        text: t`global.join_us.leadForm.category.craftsman`,
    },
    {
        value: 'smaller_business',
        text: t`global.join_us.leadForm.category.smaller_business`,
    },
    {
        value: 'street',
        text: t`global.join_us.leadForm.category.street`,
    },
    {
        value: 'restaurants',
        text: t`global.join_us.leadForm.category.restaurants`,
    },
    {
        value: 'e_commerce',
        text: t`global.join_us.leadForm.category.e_commerce`,
    },
    {
        value: 'others',
        text: t`global.join_us.leadForm.category.others`,
    },
];
